import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Card, Col, Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import { useHistory } from 'react-router-dom';
import { resetForm, selectReviewData, selectSensorsData } from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import BulkAlertFormReview from '../BulkAlertFormReview/BulkAlertFormReview';
import SingleAlertFormReview from '../SingleAlertFormReview/SingleAlertFormReview';
import { clearAppliedChannelSearch } from '../../../../redux/slices/channelListSlice/channelListSlice';

export default function AlertFormReviewLayout({
  onBack, onCreate, onClose, goToStep,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const sensorsData = useSelector(selectSensorsData);
  const reviewData = useSelector(selectReviewData);
  const failedChannelKeys = reviewData.failedChannelKeys || [];
  const isCompleted = reviewData.completed;
  const isSubmitting = !!reviewData.isSubmitting;

  useEffect(() => {
    if (isCompleted) {
      dispatch(resetForm());
      dispatch(clearAppliedChannelSearch());
      history.push('/s/alerts');
    }
  }, [isCompleted, dispatch, history]);

  const selectedChannels = sensorsData && Array.isArray(sensorsData.selectedChannels)
    ? sensorsData.selectedChannels
    : [];

  if (selectedChannels.length <= 1) {
    return (
      <SingleAlertFormReview
        goToStep={goToStep}
        onBack={onBack}
        onCreate={onCreate}
        onCancel={() => history.goBack()}
      />
    );
  }

  const hasFailures = failedChannelKeys.length > 0;

  const handleCreateClick = () => {
    if (isSubmitting) return;
    onCreate();
  };

  return (
    <div>
      <Card className="alert-card">
        <Card.Body>
          <BulkAlertFormReview />
        </Card.Body>
      </Card>

      <Row className="mt-3">
        {!hasFailures ? (
          <>
            <Col>
              <Button
                variant="secondary"
                onClick={onBack}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Go back and make changes
              </Button>
            </Col>

            <Col className="text-right">
              <Button
                variant="primary"
                onClick={handleCreateClick}
                disabled={isSubmitting}
              >
                Create Alerts
              </Button>
            </Col>
          </>
        ) : (
          <Col className="text-right">
            <Button
              variant="primary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Close
            </Button>
          </Col>
        )}
      </Row>
    </div>
  );
}

AlertFormReviewLayout.propTypes = {
  onBack: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};
